import { render, staticRenderFns } from "./settlementDesc.vue?vue&type=template&id=51ffed7a&scoped=true"
import script from "./settlementDesc.vue?vue&type=script&lang=js"
export * from "./settlementDesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ffed7a",
  null
  
)

export default component.exports